import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteCompanyInvitationApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.COMPANIES.DELETE_COMPANY_INVITATION,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteCompanyInvitationApi